import { useTranslation } from "react-i18next";
import { IconDispatcher } from "shared/Icons";
import { Button } from "shared/ui-basics";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

export const RecentWorkEmpty = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const isReadOnly = useSelector(({ auth }: any) => auth.userInfo.UserType)?.isReadOnly();

	return (
		<Card>
			<Header>
				<Emoji>👀</Emoji>
				<Title>{t("STILL_EMPTY")}</Title>
			</Header>
			<Footer>
				<Description>{t("JOURNEY_TO_BETTER_INSIGHTS")}</Description>
				<ButtonsGroup>
					{!isReadOnly && <Button variant="dark-outline" size="s" onClick={() => history.push(`/map-creation`)}>
						<div>{t("START_MAPPING")}</div>
						<IconDispatcher type="arrow-right" styling="ms-2" />
					</Button>}
					<Button variant="primary" size="s" onClick={() => window.open("https://www.youtube.com/watch?v=5q2fO0L2S6w", "_blank")}>
						<div>{t("EXPLORE_CEMANTICA")}</div>
					</Button>
				</ButtonsGroup>
			</Footer>
		</Card>
	);
};

const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 100%;
	padding: 32px;
	border-radius: 8px;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

const Emoji = styled.span`
	font-size: 36px;
	margin-bottom: 8px;
`;

const Title = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: 28px;
`;

const Footer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const Description = styled.div`
	width: 600px;

	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px;
`;

const ButtonsGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
`;
